import { Text, VStack } from 'native-base';
import React from 'react';

import { FONT_SIZE } from 'app/components/TicketCarousel/Ticket/constants';

export type TicketFieldProps = {
  label: string;
  value: string;
  selectable?: boolean;
};

export default function TicketField({ label, value, selectable = false }: TicketFieldProps) {
  return (
    <VStack space="0">
      <Text fontSize="2xs" textTransform="uppercase">
        {label}
      </Text>
      <Text bold lineHeight={FONT_SIZE} selectable={selectable}>
        {value}
      </Text>
    </VStack>
  );
}
